// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vsm--title{\n  width: 45px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
module.exports = exports;
